import Button from 'src/components/primitives/Button/Button';
import useModal from 'src/components/Modals/hooks/useModal';
import { cj } from 'src/utils/classNames';
import useTickedAllSubAccounts from 'src/hooks/useTickedAllSubAccounts';
import { MAIN_POOL_ID } from '@drift/common';
import { useMemo } from 'react';

export default function PortfolioHeaderButtons() {
	const { show } = useModal();
	const accounts = useTickedAllSubAccounts();

	const hasOtherMainPoolAccount = useMemo(() => {
		return (
			accounts.filter((account) => account.poolId === MAIN_POOL_ID).length > 1
		);
	}, [accounts]);

	return (
		<div
			className={cj(
				'grid w-full auto-cols-fr items-center gap-x-sm',
				hasOtherMainPoolAccount ? 'grid-cols-3' : 'grid-cols-2'
			)}
		>
			<Button
				size="sm"
				variant="secondary"
				onClick={() => show({ type: 'deposit', props: {} })}
				dataTestId="portfolio-deposit-button"
			>
				Deposit
			</Button>
			<Button
				size="sm"
				variant="secondary"
				onClick={() => show({ type: 'withdraw', props: {} })}
				dataTestId="portfolio-withdraw-button"
			>
				Withdraw
			</Button>
			{hasOtherMainPoolAccount && (
				<Button
					size="sm"
					variant="secondary"
					onClick={() => show({ type: 'transfer', props: {} })}
					dataTestId="portfolio-transfer-button"
				>
					Transfer
				</Button>
			)}
		</div>
	);
}
